import Constant from '@/const';
import axios from 'axios';

const getPharmacyPatientCount = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/pharmacy/count/${params.category}`),
      { params },
    );
    return response.data.data;
  } catch (error) {
    throw new Error(error);
  }
};

export default getPharmacyPatientCount;
